import { cn } from "@/lib/utils";

export function Text({
  xs,
  sm,
  md,
  lg,
  xl,
  fat,
  xxl,
  fit,
  thin,
  base,
  code,
  xxxl,
  muted,
  xxxxl,
  skinny,
  chonky,
  subdued,
  primary,
  children,
  className,
  style,
  onClick,
}: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  fat?: boolean;
  xxl?: boolean;
  fit?: boolean;
  thin?: boolean;
  base?: boolean;
  code?: boolean;
  xxxl?: boolean;
  muted?: boolean;
  xxxxl?: boolean;
  skinny?: boolean;
  chonky?: boolean;
  subdued?: boolean;
  primary?: boolean;
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
}) {
  return (
    <span
      className={cn(
        "text-lg font-medium text-pretty",
        skinny
          ? "font-thin"
          : thin
            ? "font-normal"
            : fat
              ? "font-semibold tracking-tight"
              : chonky
                ? "font-black tracking-tight"
                : "font-medium",
        xs && "text-xs",
        sm && "text-sm",
        md && "text-md",
        base && "text-base",
        lg && "text-lg",
        xl && "text-xl",
        xxl && "text-2xl tracking-tight",
        xxxl && "text-3xl tracking-tight",
        xxxxl && "text-4xl tracking-tight",
        subdued && "text-subdued-foreground",
        muted && "text-muted-foreground",
        primary && "text-primary",
        fit && "w-fit shrink-0",
        code && "font-mono",
        className,
      )}
      style={style}
      onClick={onClick}
    >
      {children}
    </span>
  );
}
